export default __webpack_public_path__ + "media/icons/live_chat-4b6594a7.svg";